module.exports = __webpack_public_path__ + "img/samsung.211c7cb3.png";